jQuery(document).ready(function ($) {
	// hide certification field if person is not
	let typeSelect = $('#reg_billing_user_role');
	let certNum = $('#reg-billing-cert-number-block');

	typeSelect.on('change', function () {
		if ( $(this).find('option:selected').val() == 1 ) {
			certNum.removeClass('hide-block');
		} else {
			certNum.addClass('hide-block');
		}
	});

	// Show or hide compay fields in registration
	let regForm = $('.woocommerce-form-register');
	let regPersonRadio = regForm.find('input[name=billing_person_type]');

	// On load
	if ( regForm.find('input[name=billing_person_type]:checked').attr('value') === 'individual' ) {
		regForm.addClass('hide-legal-fields');
	} else {
		regForm.removeClass('hide-legal-fields');
	}

	// On click
	regPersonRadio.click(function () {
		if ( $(this).attr('value') === 'individual' ) {
			regForm.addClass('hide-legal-fields');
		} else {
			regForm.removeClass('hide-legal-fields');
			/*if($('select[name="billing_user_role"] option:selected').val() == 1){
				regForm.removeClass('hide-legal-fields');
			}*/
		}
	});
});